const keywordActionsIds = {
  KEYWORD_SUBMIT: 'keyword_submit',
  KEYWORD_REDEEM: "keyword_redeem",
};

const keywordActionsList = [
  {
    id: keywordActionsIds.KEYWORD_SUBMIT,
    name: "Keyword Submit",
    description: "User submits a keyword for entry credit.",
  },
  {
    id: keywordActionsIds.KEYWORD_REDEEM,
    name: "Keyword Redeem",
    description: "User successfully redeems a keyword.",
  },
];

const rideChallengeActionsIds = {
  RC_VISIT_DEALERSHIP_LATER: "rc_visit_dealership_later",
};

const rideChallengeActionsList = [
  {
    id: rideChallengeActionsIds.RC_VISIT_DEALERSHIP_LATER,
    name: "RC Visit Dealership Later",
    description: "User clicks the 'Visit Dealership Later' button.",
  },
];

export const actionIds = {
  PAGE_VIEW: 'page_view',
  FORM_SUBMIT: "form_submit",
  ...keywordActionsIds,
  ...rideChallengeActionsIds,
};

const actionList = [
  {
    id: actionIds.PAGE_VIEW,
    name: "Page View",
    description: "Track when a user visits a page.",
  },
  {
    id: actionIds.FORM_SUBMIT,
    name: "Form Submit",
    description: "User submits a form.",
  },
  ...keywordActionsList,
  ...rideChallengeActionsList,
];

export default actionList;